<fieldset class="grid" data-test-id="aufgabe-versand-root" aria-label="Einstellungen zu MITTEILUNG">
	<div class="column">
		<fieldset
			[ngClass]="formGroup.invalid ? 'error' : 'noerror'"
			class="column empfaenger"
			aria-label="Empfänger auswählen">
			<legend>{{ formGroup.valid ? 'Empfänger' : 'Empfänger *' }}</legend>

			<mat-checkbox
				[formControl]="bodyControls.anEigentuemerNeu"
				color="primary"
				class="focus-inwards-dark"
				data-test-id="mitteilung-checkbox-eigentuemer-neu">
				Eigentümer neu
			</mat-checkbox>
			@if (bodyControls.anEigentuemerNeu.value) {
				<fieldset class="inline-group">
					<mat-checkbox
						[formControl]="eigentuemerNeuControls.ueberAnwalt"
						color="primary"
						class="focus-inwards-dark"
						data-test-id="mitteilung-eigentuemer-neu-checkbox-anwalt">
						über Rechtsanwalt
					</mat-checkbox>
					<mat-checkbox
						[formControl]="eigentuemerNeuControls.ueberNotar"
						color="primary"
						class="focus-inwards-dark"
						data-test-id="mitteilung-eigentuemer-neu-checkbox-notar">
						über Notar
					</mat-checkbox>
				</fieldset>
			}

			<mat-checkbox
				[formControl]="bodyControls.anEigentuemerAlt"
				color="primary"
				class="focus-inwards-dark"
				data-test-id="mitteilung-checkbox-eigentuemer-alt">
				Eigentümer alt
			</mat-checkbox>
			@if (bodyControls.anEigentuemerAlt.value) {
				<fieldset class="inline-group">
					<mat-checkbox
						[formControl]="eigentuemerAltControls.ueberAnwalt"
						color="primary"
						class="focus-inwards-dark"
						data-test-id="mitteilung-eigentuemer-alt-checkbox-anwalt">
						über Rechtsanwalt
					</mat-checkbox>
					<mat-checkbox
						[formControl]="eigentuemerAltControls.ueberNotar"
						color="primary"
						class="focus-inwards-dark"
						data-test-id="mitteilung-eigentuemer-alt-checkbox-notar">
						über Notar
					</mat-checkbox>
				</fieldset>
			}

			<mat-checkbox
				[formControl]="bodyControls.anNotar"
				color="primary"
				class="focus-inwards-dark"
				data-test-id="mitteilung-checkbox-notar">
				Notar
			</mat-checkbox>
			@if (bodyControls.anNotar.value) {
				<fieldset class="inline-group">
					<schir-int-client-one-value-editor
						[type]="'text'"
						[label]="'zu UVZ-Nr.'"
						[fieldControl]="notarControls.uvzNr"
						color="primary"
						data-test-id="mitteilung-notar-input-uvznr" />
				</fieldset>
			}

			<mat-checkbox
				[formControl]="bodyControls.anLuftfahrtBundesamt"
				color="primary"
				class="focus-inwards-dark"
				data-test-id="mitteilung-checkbox-lfba">
				Luftfahrtbundesamt
			</mat-checkbox>
			@if (bodyControls.anLuftfahrtBundesamt.value) {
				<fieldset class="inline-group">
					<schir-int-client-one-value-editor
						[type]="'text'"
						[label]="'zu Nr. der Luftfahrzeugrolle'"
						[fieldControl]="luftfahrtBundesAmtControls.nrLuftfahrzeugrolle"
						color="primary"
						data-test-id="mitteilung-lfba-input-nrRolle" />
				</fieldset>
			}

			<mat-checkbox
				[formControl]="bodyControls.anGlaeubigerNeu"
				color="primary"
				class="focus-inwards-dark"
				data-test-id="mitteilung-checkbox-glaeubiger-neu">
				Gläubiger neu
			</mat-checkbox>
			@if (bodyControls.anGlaeubigerNeu.value) {
				<fieldset class="inline-group">
					<mat-checkbox
						[formControl]="glaeubigerNeuControls.ruecksendung"
						color="primary"
						class="focus-inwards-dark"
						data-test-id="mitteilung-glaeubiger-neu-checkbox-ruecksendung">
						Unter Rücksendung
					</mat-checkbox>
				</fieldset>
			}

			<mat-checkbox
				[formControl]="bodyControls.anGlaeubigerAlt"
				color="primary"
				class="focus-inwards-dark"
				data-test-id="mitteilung-checkbox-glaeubiger-alt">
				Gläubiger alt
			</mat-checkbox>
			@if (bodyControls.anGlaeubigerAlt.value) {
				<fieldset class="inline-group">
					<mat-checkbox
						[formControl]="glaeubigerAltControls.ruecksendung"
						color="primary"
						class="focus-inwards-dark"
						data-test-id="mitteilung-glaeubiger-alt-checkbox-ruecksendung">
						Unter Rücksendung
					</mat-checkbox>
				</fieldset>
			}

			<mat-checkbox
				[formControl]="bodyControls.anBerechtigter"
				color="primary"
				class="focus-inwards-dark"
				data-test-id="mitteilung-checkbox-berechtigter">
				Berechtigter Abt. I/
			</mat-checkbox>
			@if (bodyControls.anBerechtigter.value) {
				<fieldset class="inline-group">
					<schir-int-client-one-value-editor
						[type]="'text'"
						[label]="'Nr. in Abt. I'"
						[fieldControl]="bodyControls.berechtigterNr"
						color="primary"
						data-test-id="mitteilung-berechtigter-input-nr" />
					<mat-checkbox
						[formControl]="berechtigterControls.ueberAnwalt"
						color="primary"
						class="focus-inwards-dark"
						data-test-id="mitteilung-berechtigter-checkbox-anwalt">
						über Rechtsanwalt
					</mat-checkbox>
					<mat-checkbox
						[formControl]="berechtigterControls.ueberNotar"
						color="primary"
						class="focus-inwards-dark"
						data-test-id="mitteilung-berechtigter-checkbox-notar">
						über Notar
					</mat-checkbox>
				</fieldset>
			}

			<mat-checkbox
				[formControl]="bodyControls.anRechtsanwalt"
				color="primary"
				class="focus-inwards-dark"
				data-test-id="mitteilung-checkbox-anwalt">
				Rechtsanwalt
			</mat-checkbox>
			@if (bodyControls.anRechtsanwalt.value) {
				<fieldset class="inline-group">
					<schir-int-client-one-value-editor
						[type]="'text'"
						[label]="'zu AZ'"
						[fieldControl]="rechtsanwaltControls.zuAz"
						color="primary"
						data-test-id="mitteilung-anwalt-input-az" />
				</fieldset>
			}
		</fieldset>
		@if (formGroup.invalid) {
			<mat-error data-test-id="invalid-checkbox-message">Bitte Empfänger wählen</mat-error>
		}
	</div>
	<schir-int-client-notiz-in-aufgabe-editor class="row note" [aufgabenTyp]="AufgabenTyp.LFPR_MITTEILUNG" />
</fieldset>
